import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AppAccess.css';

const solutions = [
  {
    title: 'DistribuiPRO Web',
    description: 'Demo del sistema web para gestion comercial y operativa.',
    action: {
      label: 'Ver demo',
      href: 'https://customsoft-solutions.com.ar/distribuidora/#/login',
      external: true,
    },
  },
  {
    title: 'DistribuiPRO App',
    description: 'App movil para pedidos y hoja de ruta.',
    action: {
      label: 'Descargar app',
      href: `/downloads/distribuiPRO.apk?v=${Date.now()}`,
      download: true,
    },
  }/**,
  {
    title: 'Ciudadania Italiana',
    description: 'Acceso a demo del sistema orientado a gestion de tramites.',
  },
  {
    title: 'Ciudadania Italiana App',
    description: 'App movil para carga y consulta de arbol genealogico y documentacion.',
  },
  {
    title: 'SiSFact',
    description: 'Sistema de facturacion y gestion administrativa.',
  },
  {
    title: 'SiSFact App',
    description: 'App movil para consulta y gestion de comprobantes.',
  },
  {
    title: 'RestauPRO Web',
    description: 'Sistema integral para la gestion de restaurantes: pedidos, mesas, caja y control de ventas.',
  },
  {
    title: 'RestauPRO App',
    description: 'App movil para tomar pedidos, gestionar mesas y optimizar la atencion al cliente.',
  }, */
];

function AppAccess() {
  const navigate = useNavigate();
  const [demoScenarios, setDemoScenarios] = useState([]);
  const [demoScenariosStatus, setDemoScenariosStatus] = useState('loading');

  useEffect(() => {
    let isMounted = true;

    fetch(`/config/demo-scenarios.json?v=${Date.now()}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('No se pudo cargar la configuracion de videos.');
        }

        return response.json();
      })
      .then((data) => {
        if (!isMounted) {
          return;
        }

        setDemoScenarios(Array.isArray(data) ? data : []);
        setDemoScenariosStatus('ready');
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }

        setDemoScenarios([]);
        setDemoScenariosStatus('error');
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('appAccess');
    navigate('/login');
  };

  return (
    <div className="app-access-page">
      <section className="app-access-hero">
        <div className="app-access-container">
          <div className="app-access-topbar">
            <div>
              <span className="app-access-kicker">Acceso clientes</span>
              <h1>Soluciones y demos disponibles</h1>
              <p>
                Desde aca podes acceder a las demos activas, ingresar a plataformas de prueba,
                descargar la app movil y consultar videos guiados.
              </p>
            </div>

            <button className="logout-btn" onClick={handleLogout}>
              Cerrar sesion
            </button>
          </div>
        </div>
      </section>

      <section className="app-access-section">
        <div className="app-access-container">
          <div className="app-access-grid">
            {solutions.map((solution) => (
              <article className="app-access-card" key={solution.title}>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
                <div className="app-access-actions">
                  {solution.action ? (
                    <a
                      href={solution.action.href}
                      target={solution.action.external ? '_blank' : undefined}
                      rel={solution.action.external ? 'noreferrer' : undefined}
                      download={solution.action.download}
                    >
                      {solution.action.label}
                    </a>
                  ) : (
                    <span className="disabled-link">No habilitado</span>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="app-access-section app-access-video-section">
        <div className="app-access-container">
          <div className="app-access-section-heading">
            <span className="app-access-kicker">Videos demo</span>
            <h2>Guias por escenario</h2>
            <p>Material de apoyo para ver los pasos principales de cada proceso.</p>
          </div>

          {demoScenariosStatus === 'loading' && (
            <div className="demo-config-message">Cargando videos demo...</div>
          )}

          {demoScenariosStatus === 'error' && (
            <div className="demo-config-message demo-config-message-error">
              No se pudieron cargar los videos demo. Revisar el archivo de configuracion.
            </div>
          )}

          {demoScenariosStatus === 'ready' && demoScenarios.length === 0 && (
            <div className="demo-config-message">No hay videos demo configurados.</div>
          )}

          {demoScenariosStatus === 'ready' && demoScenarios.length > 0 && (
            <div className="demo-scenarios">
              {demoScenarios.map((scenario) => (
                <article className="demo-scenario-card" key={scenario.title}>
                  <div className="demo-scenario-header">
                    <h3>{scenario.title}</h3>
                    <p>{scenario.description}</p>
                  </div>

                  <div className="demo-video-list">
                    {(scenario.videos || []).map((video) => (
                      <div className="demo-video-item" key={video.title}>
                        <div>
                          <h4>{video.title}</h4>
                          <p>{video.comment}</p>
                        </div>

                        {video.url ? (
                          <a href={video.url} target="_blank" rel="noreferrer">
                            Ver video
                          </a>
                        ) : (
                          <span className="disabled-link">Pendiente</span>
                        )}
                      </div>
                    ))}
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default AppAccess;
